export default {
  title: 'Články',
  subtitle: 'Novinky, návody a aktuality od týmu PlayStock.',
  loadFailed: 'Články se nepodařilo načíst. Zkuste to prosím znovu.',
  emptyTitle: 'Zatím žádné články',
  emptyBody: 'Brzy se vraťte pro novinky a návody.',
  featured: 'Doporučené',
  readArticle: 'Přečíst článek',
  latest: 'Nejnovější články',
  readingMinutes: '{n} min čtení',
  read: 'Číst',
  backToArticles: 'Zpět na články',
  notFound: 'Článek nenalezen',
  shareThis: 'Sdílet tento článek',
  copyLink: 'Kopírovat odkaz',
  linkCopied: 'Odkaz zkopírován',
};
